module.exports = __webpack_public_path__ + "img/00—Captive portal page.0c572b53.jpg";